<template>
  <div id="app">
      <router-view/>
  </div>
</template>
<script>
export default {
  name: 'app',
  created () {
    this.getKey()
  },
  methods: {
    getKey () {
      this.$api.get(this.$face.LoginUrl.getPulicKey, {}, (r) => {
        if (r.status) {
          localStorage.setItem('publickey', r.detail)
        } else {
          this.$face.overdue(r.errorCode, r.userMessage)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue